import React, { Component } from 'react';
import { connect } from 'react-redux';
import BottomButtonsNew from '../../shared/BottomButtonsNew/BottomButtonsNew';
import MessageScreen from '../../shared/MessageScreen/MessageScreen';
import Pinata from './Pinata';
import { fbLogin } from '../../helpers/facebookLogin';
import { mapStateToProps, mapDispatchToProps } from '../../reducers/_dispatchers';
import { getPrize } from '../../actions/getPrizeActions';
import { FaFacebook, FaSpinner } from 'react-icons/fa';
import { Xplosion } from '../../constants/assets';

class Play extends Component {
    constructor(props) {
        super(props);
        const { Account: { isLogged, playedDate, tomorrow, playedTimes } } = props;
        this.state = {
            isLoading: false,
            isLoggined: isLogged || false,
            gameStartedBefore: false,
            gameStarted: false,
            playedDate,
            tomorrow,
            playedTimes,
            motionDetected: false,
            isMotionStyle: true,
            winned: false
        };
    }

    componentWillMount() {
        const today = new Date();
        const { tomorrow } = this.state;
        const playedDate = today.getFullYear() + today.getMonth() + 1 + today.getDate();
        if(playedDate >= tomorrow) {
            const today = new Date();
            this.setState({
                playedTimes: 0,
                playedDate: today.getFullYear() + today.getMonth() + 1 + today.getDate(),
                tomorrow: today.getFullYear() + today.getMonth() + 1 + today.getDate() + 1
            });
            this.props.resetDate();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            Account: { isLogged, errorLogin },
            setError
        } = nextProps;
        if(isLogged || errorLogin) {
            const isLoggined = isLogged || false;
            if(errorLogin) {
                setError();
            }
            this.setState({
                isLoggined,
                isLoading: false
            });
        }
    }

    playGame = () => {
        const { Account } = this.props;
        const profileID = Account && Account.profile && Account.profile.social_id ? Account.profile.social_id : '';
        getPrize({
            profileID
        });
        this.setState({
            gameStarted: true
        });
    }

    startGameBefore = () => {
        this.setState({
            gameStartedBefore: true
        });
    }

    winTheGame = () => {
        this.setState({
            gameStarted: false,
            winned: true
        });
        setTimeout(() => {
            this.props.history.push('/prize-winned');
        }, 1100);
    }

    runFbLogin = () => {
        this.setState({
            isLoading: true
        });
        fbLogin(true);
    }

    changeMode = () => {
        this.setState({
            isMotionStyle: false,
            motionDetected: true,
        });
    }

    motionAlreadyDetected = () => {
        this.setState({
            motionDetected: true,
        });
    }

    render() {
        const {
            isLoading,
            isLoggined,
            isMotionStyle,
            gameStarted,
            gameStartedBefore,
            motionDetected,
            playedTimes,
            winned
        } = this.state;
        const isLoadingBtn = isLoading ? <FaSpinner /> : '';
        const isLoadingBtnClass = isLoading ? 'loadin-button' : '';
        const mainTitle = motionDetected ? (
            isMotionStyle ? '¡Agita tu celular!' : '¡Mueve la piñata con tu dedo!') : null;
        const playinContainerClass = gameStarted ? 'playing-now' : '';
        const theRealContent = playedTimes < 5 ? (
            <div className={`play-page text-center ${playinContainerClass}`}>
                {!winned && gameStarted && <h1>{mainTitle}</h1>}
                { /*!gameStarted &&
                    <p>¡Rompe la piñata y conoce los sabores de estas fiestas!</p>
                */ }
                {!winned && <Pinata
                    changeMode={this.changeMode.bind(this)}
                    gameStarted={gameStarted}
                    gameStartedBefore={gameStartedBefore}
                    motionAlreadyDetected={this.motionAlreadyDetected.bind(this)}
                    startGameBefore={this.startGameBefore.bind(this)}
                    winTheGame={this.winTheGame.bind(this)}
                    winned={winned} />
                }
                {winned && <Xplosion />}
                {!winned && !gameStarted && isLoggined &&
                    <div className="play-action-buttons">
                        <button
                            onClick={this.playGame}
                            disabled={isLoading}
                            className={`button play-button`}
                        ></button>
                    </div>
                }
                {!winned && !gameStarted && !isLoggined &&
                    <div className="play-action-buttons">
                        <button
                            onClick={this.runFbLogin}
                            disabled={isLoading}
                            className={`button fb-login ${isLoadingBtnClass}`}
                        ><span>
                            <FaFacebook />
                            <i>Regístrate<br />para GANAR</i>
                        </span>{isLoadingBtn}</button>
                        <button
                            onClick={this.playGame}
                            disabled={isLoading}
                            className={`button play-button-text`}
                        >Juega sin registro</button>
                    </div>
                }
                {!winned &&
                    <BottomButtonsNew
                        logo
                    />
                }
            </div>
        ) : <MessageScreen message="Regresa mañana para intentarlo de nuevo." buttons={{logo:true}} />;

        return theRealContent;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Play);
